import { render, staticRenderFns } from "./ReplyCommentForm.vue?vue&type=template&id=45ece76a&scoped=true&"
import script from "./ReplyCommentForm.vue?vue&type=script&lang=js&"
export * from "./ReplyCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplyCommentForm.vue?vue&type=style&index=0&id=45ece76a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ece76a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
